/* import __COLOCATED_TEMPLATE__ from './delete-folder.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
var Pages = /*#__PURE__*/function (Pages) {
  Pages["Start"] = "start";
  Pages["Confirm"] = "confirm";
  Pages["Success"] = "success";
  Pages["Error"] = "error";
  Pages["TransferOut"] = "transfer-out";
  Pages["SquareBalances"] = "square-balance";
  return Pages;
}(Pages || {});
var Errors = /*#__PURE__*/function (Errors) {
  Errors["Negative"] = "negative";
  Errors["Pending"] = "pending";
  Errors["Unknown"] = "unknown";
  return Errors;
}(Errors || {});
const modalPages = new Set([Pages.Confirm, Pages.Success, Pages.TransferOut, Pages.SquareBalances]);
let DeleteFolder = (_class = class DeleteFolder extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "currentPage", _descriptor2, this);
    _initializerDefineProperty(this, "pages", _descriptor3, this);
    _initializerDefineProperty(this, "currentError", _descriptor4, this);
    _initializerDefineProperty(this, "errors", _descriptor5, this);
    _initializerDefineProperty(this, "features", _descriptor6, this);
    _defineProperty(this, "squareBalanceAccounts", []);
    _defineProperty(this, "destinationAccount", this.args.primaryAccount);
    const pendingIn = this.args.account.pendingBalance.amount;
    const available = this.args.account.availableBalance?.amount || 0;
    const total = this.args.account.totalBalance.amount || 0;
    // We don't store the pending out value but if you have some funds that are
    // unavailable this is probably why
    const pendingOut = available < total;
    if (pendingIn || pendingOut) {
      this.currentPage = Pages.Error;
      this.currentError = Errors.Pending;
    } else if (available < 0) {
      this.currentPage = Pages.Error;
      this.currentError = Errors.Negative;
    }
  }
  get showModal() {
    return modalPages.has(this.currentPage);
  }
  get totalBalance() {
    return this.args.account.totalBalance;
  }
  async onSubmit(evt) {
    evt.preventDefault();
    if (!this.isLoading) {
      this.isLoading = true;
      try {
        await this.args.delete();
        await this.args.success();
      } catch {
        this.currentPage = Pages.Error;
        this.currentError = Errors.Unknown;
      } finally {
        this.isLoading = false;
      }
    }
  }
  onContinue(evt) {
    evt.preventDefault();
    if (this.features.isEnabled('banking/access_sfs_savings')) {
      this.currentPage = this.pages.Confirm;
    } else {
      this.currentPage = this.pages.TransferOut;
    }
  }
  onTransferToSquareBalance(evt) {
    evt.preventDefault();
    this.squareBalanceAccounts = this.args.listBalances;
    this.currentPage = this.pages.SquareBalances;
  }
  onAccountSelection(destination) {
    this.destinationAccount = destination;
    this.currentPage = this.pages.Confirm;
  }
  async confirm(evt) {
    evt.preventDefault();
    this.isLoading = true;
    try {
      await this.args.delete();
      this.currentPage = this.pages.Success;
    } catch {
      this.currentPage = Pages.Error;
      this.currentError = Errors.Unknown;
    } finally {
      this.isLoading = false;
    }
  }
  onDismiss() {
    if (this.currentPage === this.pages.Success) {
      this.args.success();
    } else {
      this.args.cancel();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentPage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Pages.Start;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pages", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Pages;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "currentError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Errors.Unknown;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Errors;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onContinue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onContinue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTransferToSquareBalance", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTransferToSquareBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAccountSelection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAccountSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDismiss"), _class.prototype), _class);
export { DeleteFolder as default };